var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conveyance"},[_c('div',{staticClass:"conveyance__title"},[_c('SectionTitle',{attrs:{"mandatory":true,"title":_vm.$t('myInsurance.conveyance.conveyance'),"popoverData":_vm.popoverData}})],1),_c('div',{staticClass:"conveyance__content"},[_c('ConveyanceComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }